// Color mapping for container names
const colors = [
  'text-red-400', 'text-orange-400', 'text-amber-400', 'text-yellow-400',
  'text-lime-400', 'text-green-400', 'text-emerald-400', 'text-teal-400',
  'text-cyan-400', 'text-sky-400', 'text-blue-400', 'text-indigo-400',
  'text-violet-400', 'text-purple-400', 'text-fuchsia-400', 'text-pink-400', 'text-rose-400'
];

export const getContainerColor = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index];
};

